import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { JobProcedureService } from "src/app/services/sections/job/job-procedure.service";
import { GlobalSettingsService } from "src/app/services/ui/global-settings.service";

@Component({
  selector: "procedure-copilot-confirmation-expired",
  templateUrl: "./procedure-copilot-confirmation-expired.component.html",
  styleUrls: [
    "./procedure-copilot-confirmation-expired.component.scss",
    "../job-details/job-details.component.scss",
    "../stylesheets/job-actions.scss",
    "../stylesheets/job-main.scss",
  ],
})
export class ProcedureCopilotConfirmationExpiredComponent
  implements OnInit, AfterViewInit
{
  public isLinkRefreshed: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private procedureService: JobProcedureService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  public onRefreshLinkClick(): void {
    GlobalSettingsService.isSecondaryLoaderLoading = true;
    this.procedureService
      .refreshCopilotConfirmationLink(
        this.route.snapshot.paramMap.get("token")!
      )
      .subscribe(
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.isLinkRefreshed = true;
        },
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.isLinkRefreshed = false;
        }
      );
  }
}
